import { render, staticRenderFns } from "./pop_preview_program.vue?vue&type=template&id=48be2064&scoped=true&"
import script from "./pop_preview_program.vue?vue&type=script&lang=js&"
export * from "./pop_preview_program.vue?vue&type=script&lang=js&"
import style0 from "./pop_preview_program.vue?vue&type=style&index=0&id=48be2064&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48be2064",
  null
  
)

export default component.exports